import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export const putConfigs = async (datas: any) => {
  try {
    const response = await axios.put(`${API_URLS}/configuration-points/1`, {data: datas})
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}




export const getConfigDetail = async (id: any) => {
  let url = `${API_URLS}/configuration-points/${id}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getConfigs = async () => {
  try {
    const response = await axios.get(`${API_URLS}/configuration-points/1`)
    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  }
}